import React, { createContext, useContext, useState, useEffect } from 'react';
import { ethers } from 'ethers';

const Web3Context = createContext();

const SEPOLIA_CHAIN_ID = '0xaa36a7'; // Sepolia 테스트넷의 체인 ID (16진수)

export const Web3Provider = ({ children }) => {
    const [account, setAccount] = useState(null);
    const [provider, setProvider] = useState(null);
    const [signer, setSigner] = useState(null);
    const [isSepolia, setIsSepolia] = useState(false);

    // 메타마스크 계정 및 네트워크 변경 이벤트 리스너 등록
    useEffect(() => {
        if (window.ethereum) {
            window.ethereum.on('accountsChanged', handleAccountsChanged);
            window.ethereum.on('chainChanged', handleChainChanged);
            
            return () => {
                window.ethereum.removeListener('accountsChanged', handleAccountsChanged);
                window.ethereum.removeListener('chainChanged', handleChainChanged);
            };
        }
    }, []);

    const handleAccountsChanged = (accounts) => {
        if (accounts.length > 0) {
            setAccount(accounts[0]);
        } else {
            setAccount(null); // 사용자가 직접 지갑 연결을 해제한 경우
        }
    };

    const handleChainChanged = (chainId) => {
        setIsSepolia(chainId === SEPOLIA_CHAIN_ID);
        window.location.reload(); // 네트워크 변경 시 예기치 않은 버그 방지를 위해 새로고침 권장 (MetaMask 공식 가이드)
    };

    const connectWallet = async () => {
        if (!window.ethereum) {
            alert("메타마스크(MetaMask) 확장 프로그램을 설치해 주세요!");
            return;
        }

        try {
            // 계정 접근 권한 요청
            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
            const browserProvider = new ethers.BrowserProvider(window.ethereum);
            const browserSigner = await browserProvider.getSigner();
            
            setAccount(accounts[0]);
            setProvider(browserProvider);
            setSigner(browserSigner);

            // 네트워크 확인 및 전환
            const network = await browserProvider.getNetwork();
            const chainIdHex = '0x' + network.chainId.toString(16);
            setIsSepolia(chainIdHex === SEPOLIA_CHAIN_ID);

            if (chainIdHex !== SEPOLIA_CHAIN_ID) {
                await switchToSepolia();
            }
        } catch (error) {
            console.error("지갑 연결 실패:", error);
        }
    };

    const switchToSepolia = async () => {
        try {
            await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: SEPOLIA_CHAIN_ID }],
            });
        } catch (error) {
            console.error("네트워크 변경 실패:", error);
        }
    };

    return (
        <Web3Context.Provider value={{ account, provider, signer, isSepolia, connectWallet }}>
            {children}
        </Web3Context.Provider>
    );
};

export const useWeb3 = () => useContext(Web3Context);